export const defaultLanguage = "fa" as const;

export const supportedLanguages = ["fa", "ar"] as const;

export const namespaces = [
  "page",
  "alert",
  "action",
  "common",
  "zod",
  "fieldDescription",
  "field",
  "entity",
  "component",
  "error",
  "pageTitle",
  "sidebar",
  "subtitle",
] as const;

export const defaultNamespace = "common" as const;

export type ITranslationLanguage = (typeof supportedLanguages)[number];
export type ITranslationNamespace = (typeof namespaces)[number];

export function resolveI18nLanguage(language: string): ITranslationLanguage {
  return supportedLanguages.includes(language as ITranslationLanguage)
    ? (language as ITranslationLanguage)
    : defaultLanguage;
}
